






import Vue from 'vue';
import animationHandler from '@/helpers/animation';

export default Vue.extend({
    name: 'opening',
    methods: {
        changeView() {
            this.$emit('changeview');
        },
    },
    mounted() {
        // Initiate the animation.
        // TODO: Instead of an arbitrary setTimeout delay, poll for the element to exist.
        setTimeout(() => {
            const animationElementsArray = Array.prototype.slice
                .call(document.querySelectorAll('#name [data-animate]'));

            animationHandler(animationElementsArray, 300);
        }, 1000);
    },
    props: [
        'currentView',
    ],
});
